import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import _ from 'lodash'

import Phone from 'components/shared/Phone'
import { fontSize, SHOPIFY_GRAY } from 'components/styles'
import PhoneContent from './productsSlideWizard/PhoneContent'
import MoveLinkUI from './productsSlideWizard/MoveLinkUI'
import ChangeBackgroundImage from './productsSlideWizard/ChangeBackgroundImage'
import BackgroundCropResize from './productsSlideWizard/BackgroundCropResize'
import generate from 'firebase-auto-ids'
import ProductsSelector from './productsSlideWizard/ProductsSelector'
import { setCustomField, updateNumberOfSlidesSimple, updateCustomStyleEffect } from 'controllers/logic'
import { POSITION, HIDDEN } from 'constants/stylePresetType'
import { setShopifyBarTitle } from 'controllers/shopifyBar'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${SHOPIFY_GRAY};
  display: flex;
  align-items: center;
  ${fontSize}
  line-height: 1
`
const PhoneContainer = styled.div`
  position: relative;
  flex: 1;
  height: 100%;
  display: flex;
`
const CenteredLayer = styled.div`
  position: absolute;
  top: 0;
  right: 10%;
  height: 80%;
  margin-top: 2em;
`
const EditorWrapper = styled.div`
  flex: 1.5;
  height: 100%;
`
const EditorContainer = styled.div`
  ${fontSize}
  margin-top: 2em;
  margin-right: 2em;
  max-width: 64em;
  height: 100%;

  & .Polaris-Card {
    max-height: calc(100% - 4em);
    display: flex;
    flex-direction: column;
  }

  & .Polaris-Card__Section {
    display: flex;
    flex-direction: column;
    flex-grow: 10;
  }
`
// modes
const PRODUCT = 'PRODUCT'
const PRODUCT_LINK_MOVE = 'PRODUCT_LINK_MOVE'
const BACKGROUND_IMAGE = 'BACKGROUND_IMAGE'
const CROP_RESIZE = 'CROP_RESIZE'
const PRODUCTS_OPTIONS = 'PRODUCTS_OPTIONS'


class ProductsSlideWizard extends Component {

  constructor (props) {
    console.log('ProductsSlideWizard constructor', props.customizedSettings)
    super(props)
    this.state = {
      mode: PRODUCT,
      productIdx: 0,
      showcase: this.initShowcase(props)
    }
    setShopifyBarTitle('Add product(s)')
  }


  initShowcase = (props) => {
    // console.log('init showcase')
    const { idx, app, customizedSettings } = props
    if (_.isNil(idx)) {
      // console.log('create a new slide')
      return this.defaultShowcase()
    } else {
      // console.log('edit existing slide', idx)
      const existingShowcase = _.get(customizedSettings, ['showcases', idx])
      const showcase = Object.assign(this.defaultShowcase(), existingShowcase)
      const style0 = _.get(app, ['customFields', 'customStyles', `ou_showcase_link_p${showcase.slideId}_${0}`])
      const style1 = _.get(app, ['customFields', 'customStyles', `ou_showcase_link_p${showcase.slideId}_${1}`])

      const positionStyle0 = _.get(style0, POSITION)
      // console.log('position style 0', positionStyle0)
      if (positionStyle0 && positionStyle0.x && positionStyle0.y) {
        showcase.products[0].offsetX = positionStyle0.x
        showcase.products[0].offsetY = positionStyle0.y
      }

      const hiddenStyle0 = _.get(style0, HIDDEN)
      if (hiddenStyle0 && hiddenStyle0.value === true) showcase.products[0].productId = ''

      const positionStyle1 = _.get(style1, POSITION)
      // console.log('position style 1', positionStyle1)
      if (positionStyle1 && positionStyle1.x && positionStyle1.y) {
        showcase.products[1].offsetX = positionStyle1.x
        showcase.products[1].offsetY = positionStyle1.y
      }

      const hiddenStyle1 = _.get(style1, HIDDEN)
      if (hiddenStyle1 && hiddenStyle1.value === true) _.set(showcase, ['products', 1, 'productId'], '')

      // console.log('initShowcase', showcase)
      return showcase
    }
  }

  defaultShowcase = () => {
    return {
      slideId: generate(_.now()),
      image: null,
      products: [
        {
          x: 10,
          y: -22,
          title: '',
          productId: null
        },
        {
          x: 10,
          y: 22,
          title: '',
          productId: null
        }
      ]
    }
  }


  onPlay = () => this.setState({iaStarted: true})

  applyProductLinkPosition = (productIdx, product) => {
    // console.log('applyProductLinkPosition')
    const { app, dispatch } = this.props
    const { showcase } = this.state
    const offsetX = _.get(product, 'offsetX', 0)
    const offsetY = _.get(product, 'offsetY', 0)
    dispatch(updateCustomStyleEffect(
      app,
      `ou_showcase_link_p${showcase.slideId}_${productIdx}`,
      POSITION,
      { x: offsetX, y: offsetY }
    ))
  }

  saveAndExit = () => {
    // console.log('saveAndExit')
    const { stopProductsSlideWizard, dispatch, app, idx } = this.props
    const { showcase } = this.state
    const currentShowcases = _.clone(_.get(app, 'customFields.showcases', []))
    const product0 = showcase.products[0]
    const product1 = showcase.products[1]
    const realShowcase = {
      slideId: showcase.slideId,
      image: showcase.image,
      products: [
        {
          x: product0.x,
          y: product0.y,
          title: product0.title,
          productId: product0.productId
        }
      ]
    }

    if (!_.isNil(product1.productId) && product1.productId !== '') { //the second product is configured
      const p1 = {
        x: product1.x,
        y: product1.y,
        title: product1.title,
        productId: product1.productId
      }
      realShowcase.products.push(p1)
      // remove style for hidden if exists
      dispatch(updateCustomStyleEffect(
        app,
        `ou_showcase_link_p${showcase.slideId}_1`,
        HIDDEN,
        { value: null }
      ))
    } else { // the second product has to be hidden
      // console.log('the second product is hidden')
      dispatch(updateCustomStyleEffect(
        app,
        `ou_showcase_link_p${showcase.slideId}_1`,
        HIDDEN,
        { value: true }
      ))
    }

    this.applyProductLinkPosition(0, product0)
    this.applyProductLinkPosition(1, product1)

    if (_.isNil(idx)) {
      currentShowcases.push(realShowcase)
      // console.log('new showcases', currentShowcases, ' realShowcase', realShowcase)
      dispatch(updateNumberOfSlidesSimple(app.id, app.slidesCnt + 1))
      dispatch(setCustomField(app.id, 'showcases', currentShowcases))
      // console.log('The slide is new')
    } else {
      const showcaseCopy = Object.assign(currentShowcases[idx], showcase)
      _.unset(showcaseCopy, ['products', 0, 'offsetX'])
      _.unset(showcaseCopy, ['products', 0, 'offsetY'])
      _.unset(showcaseCopy, ['products', 1, 'offsetX'])
      _.unset(showcaseCopy, ['products', 1, 'offsetY'])
      dispatch(setCustomField(app.id, `showcases/${idx}`, showcaseCopy))
      // console.log('Update existing slide')
    }
    stopProductsSlideWizard()
  }

  showProduct = (productId) => {
    // console.log('showProduct')
  }

  changeProductIdx = (idx) => {
    this.setState({
      productIdx: idx,
      mode: PRODUCT
    })
  }

  enableLinkMoveMode = (isEnable) => {
    // console.log('enableLinkMoveMode', isEnable)
    this.setState({
      mode: isEnable ? PRODUCT_LINK_MOVE : PRODUCT
    })
  }

  updateProduct = (productIdx, newProduct) => {
    const showcaseCopy = _.clone(this.state.showcase)
    showcaseCopy.products[productIdx] = newProduct
    // console.log('updateProduct', showcaseCopy)
    this.setState({
      showcase: showcaseCopy
    })
  }

  renderPhoneContent () {
    const { showcase, productIdx, mode } = this.state
    return (
      <PhoneContent
        slideId={showcase.slideId}
        showcase={showcase}
        productIdx={productIdx}
        changeProductIdx={this.changeProductIdx}
        isMoveMode={mode === PRODUCT_LINK_MOVE}
        enableLinkMoveMode={this.enableLinkMoveMode}
        updateProduct={this.updateProduct}
        productLinksEditable={mode !== BACKGROUND_IMAGE && mode !== CROP_RESIZE && mode !== PRODUCTS_OPTIONS}
      />
    )
  }

  toMode = (mode, productIdx = 0) => {
    this.setState({mode: mode, productIdx})
  }

  onBack = () => {
    const { mode, productIdx } = this.state
    const { stopProductsSlideWizard } = this.props
    switch (mode) {
      case PRODUCT:
        if (productIdx === 0) {
          stopProductsSlideWizard(true)
        } else {
          this.toMode(PRODUCT, 0)
        }
        break
      case BACKGROUND_IMAGE:
        this.toMode(PRODUCT, 1)
        break
      case PRODUCTS_OPTIONS:
        this.toMode(PRODUCT, 1)
        break
    }
  }

  onNext = () => {
    const { mode, productIdx } = this.state
    switch (mode) {
      case PRODUCT:
        if (productIdx === 0) {
          this.toMode(PRODUCT, 1)
        } else {
          this.saveAndExit()
          // this.toMode(PRODUCTS_OPTIONS)
        }
        break
      case BACKGROUND_IMAGE:
        this.toMode(PRODUCT, 1)
        break
      case PRODUCTS_OPTIONS:
        this.saveAndExit()
        break
    }
  }

  resetLinkPosition = (productIdx) => {
    return () => {
      // console.log('resetLinkPosition')
      const productCopy = _.clone(_.get(this.state.showcase, ['products', productIdx]))
      productCopy.offsetX = 0
      productCopy.offsetY = 0
      this.updateProduct(productIdx, productCopy)
    }
  }

  moveLinkDone = () => {
    const { productIdx } = this.state
    this.toMode(PRODUCT, productIdx)
  }

  setShowcaseImage = (url) => {
    // console.log('setShowcaseImage', url)
    const showcase = _.clone(this.state.showcase)
    showcase.image = url
    // console.log('new Showcase', showcase)
    this.setState({
      showcase: showcase
    })
  }

  toProduct1 = () => {
    this.toMode(PRODUCT, 1)
  }

  toChangeBackgroundStep = () => {
    this.toMode(BACKGROUND_IMAGE)
  }

  toCropResizeStep = () => {
    this.toMode(CROP_RESIZE)
  }

  renderEditorUI () {
    const { app } = this.props
    const { mode, showcase, productIdx } = this.state
    switch (mode) {
      case PRODUCT:
      const product = showcase.products[productIdx]
        return (
          <ProductsSelector
            onBack={this.onBack}
            onNext={this.onNext}
            product={product}
            productIdx={productIdx}
            updateProduct={this.updateProduct}
            setShowcaseImage={this.setShowcaseImage}
            toChangeBackgroundStep={this.toChangeBackgroundStep}
          />
        )
      case PRODUCT_LINK_MOVE:
        return (
          <MoveLinkUI
            resetLinkPosition={this.resetLinkPosition(productIdx)}
            moveLinkDone={this.moveLinkDone}
          />
        )
      case BACKGROUND_IMAGE:
        return (
          <ChangeBackgroundImage
            onDone={this.onNext}
            app={app}
            currentImageUrl={showcase.image}
            setShowcaseImage={this.setShowcaseImage}
            toCropResizeStep={this.toCropResizeStep}
          />
        )
      case CROP_RESIZE:
        return (
          <BackgroundCropResize
            app={app}
            image={showcase.image}
            onBack={this.toChangeBackgroundStep}
            setShowcaseImage={this.setShowcaseImage}
            onDone={this.toProduct1}
          />
        )
      default:
        return <div>this is not implemented yet</div>
    }
  }

  render () {
    // console.log('Products slide wizard showcase', this.state.showcase)
    return (
      <Wrapper key={this.uniqId}>
        <PhoneContainer>
          <CenteredLayer>
            <Phone needOffset={false}>
              {this.renderPhoneContent()}
            </Phone>
          </CenteredLayer>
        </PhoneContainer>
        <EditorWrapper>
          <EditorContainer>
            {this.renderEditorUI()}
          </EditorContainer>
        </EditorWrapper>
      </Wrapper>
    )
  }

}

ProductsSlideWizard.propTypes = {
  idx: PropTypes.number,
  app: PropTypes.object.isRequired,
  stopProductsSlideWizard: PropTypes.func.isRequired,
  customizedSettings: PropTypes.object
}

export default connect()(ProductsSlideWizard)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/ProductsSlideWizard.js